import { TransactionSign, TransactionType } from '@/features/transactions/types/transactions-dto';

export type FinanceBalanceApartmentResponseDto = {
    apartmentId: string;
    apartmentName?: string;
    property: number;
    otherServices: number;
};

export type FinanceBalanceResponseDto = {
    property: number;
    otherServices: number;
    apartments?: FinanceBalanceApartmentResponseDto[];
};

export type FinanceBalanceSummaryResponseDto = {
    balance: number;
};

export type FinanceAnalyticsResponseDto = {
    revenue: number;
    expenses: number;
    income: number;
    vat: number;
    commissions: number;
    incomeTax: number;
    internet: number;
    water: number;
    electricity: number;
    gas: number;
    grossRevenue: number;
    deduction: number;
    transferredFunds: number;
};

export type FinanceAnalyticsByMonthsMonthResponseDto = {
    month: Date;
    value: number;
};

export type FinanceAnalyticsByMonthsResponseDto = {
    revenue: number;
    expenses: number;
    income: number;
    vat: number;
    commissions: number;
    incomeTax: number;
    internet: number;
    water: number;
    electricity: number;
    gas: number;
    grossRevenue: number;
    deduction: number;
    transferredFunds: number;
    previousMonthUtilities: number;
    revenueMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    expensesMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    incomeMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    vatMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    commissionsMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    incomeTaxMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    internetMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    waterMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    electricityMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    gasMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    grossRevenueMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    deductionMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    transferredFundsMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
    previousMonthUtilitiesMonths: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
};

export type FinanceTransactionItemResponseDto = {
    id: string;
    apartmentName?: string;
    serviceName?: string;
    transactionType: TransactionType;
    amount: number;
    sign: TransactionSign;
};

export type FinanceTransactionsResponseDto = {
    transactions?: {
        [key: string]: FinanceTransactionItemResponseDto[];
    };
};

export enum SettlementsType {
    Property = 'property',
    OtherServices = 'otherServices',
}
